import { commonAppLog, useInitCommonAppLogs } from '@actr/widgets/src/logs/common-app';

const appLog = commonAppLog.extend();

export function useInitAppLogs() {
  useInitCommonAppLogs();
}

export default appLog;
